import { IpRightImportStatusInfo } from "../state/modern_states"

type PaymentHandlingAction = 'edit' | 'initiate' | 'reactivate'

export function paymentHandlingAction({status, imported}: {status: IpRightImportStatusInfo, imported: boolean}): PaymentHandlingAction {
    // console.log({status, imported})
    return (status.substatus === 'stopped' || status.substatus === 'inactive') && imported
        ? 'reactivate'
        : status.status === 'ready'
        ? 'edit'
        : 'initiate'
}

export function renewalHandlingActionName(paymentHandlingAction: PaymentHandlingAction) {
    return {
        'edit': 'edit-payment-handling',
        'initiate': 'initiate-payment-handling',
        'reactivate': 'reactivate-payment-handling',
    }[paymentHandlingAction]
}